<div class="form-style gpd-scroll">
    <div class="gallery-wrapper">
        <div class="gallery-section" *ngIf="foldersLoaded">
            <dx-tree-list [dataSource]="galleryFolderData" dataStructure="tree" [showColumnHeaders]="false"
                keyExpr="key" parentIdExpr="parentId" [selection]="{mode:'single'}" (onNodesInitialized)="onNodesInitialized($event)">
                <dxo-row-dragging [allowReordering]="true" [allowDropInsideItem]="true" [onReorder]="onReorder"
                    [onDragChange]="onDragChange" dragDirection="both">
                </dxo-row-dragging>
                <dxi-column cellTemplate="nameTemplate" dataField="name" caption="Folder"></dxi-column>
                <div *dxTemplate="let item of 'nameTemplate'">
                    <div class="gallery-folder-row" (click)="handleFolderRowClick(item)"
                        (contextmenu)="onContextMenu($event, item.data)"
                        (dragenter)="onFolderDragEnter($event, item.data)" (dragover)="onFolderDragOver($event)"
                        (dragleave)="onFolderDragLeave($event)" (drop)="onImageDropToFolder($event, item.data)"
                        [attr.data-folder-key]="item.data.key">
                        <span class="gallery-folder-item {{item.data.selected===true?'selected' :''}}">
                            <i class="dx-icon-{{item.data.isDirectory ? 'folder' : 'file'}}"></i> {{item.value}}
                        </span>
                    </div>
                </div>
            </dx-tree-list>

            <dx-context-menu #fileContextMenu [items]="contextMenuItems" target=".gallery-folder-row"
                [position]="{ my: 'left top', at: 'left bottom' }" (onItemClick)="onContextMenuItemClick($event)">
            </dx-context-menu>
        </div>
        <div class="gallery-section">
            <div *ngIf="selectedFolder != null" class="gallery-file-box" (drop)="onDrop($event)"
                (dragover)="onDragOver($event)" (click)="triggerFileInput()">
                <p i18n="@@dropPicture">Drop and picture file here to add it to the gallery</p>
                <input #commentFileInput type="file" accept="image/*" name="upload" style="display: none;"
                    (change)="setFiles($event.target.files)" multiple />
            </div>

            <dx-tile-view *ngIf="galleryVisible" [noDataText]="noDataText" (onItemRendered)="queueImageDownload($event)"
                (onItemClick)="handleImageClick($event)" class="dx-tile-content" direction="vertical"
                [baseItemHeight]="120" [baseItemWidth]="185" width="100%" [itemMargin]="10" height="100%">
                <dxi-item *ngFor="let item of galleryData; let i = index" [widthRatio]="item.widthRatio"
                    [heightRatio]="item.heightRatio">
                    <div class="gallery-image gallery-image-loading draggable-image" draggable="true"
                        (dragstart)="onImageDragStart($event, item, i)" (dragend)="onImageDragEnd($event)"
                        [attr.data-image-index]="i">
                        &nbsp;
                    </div>
                </dxi-item>
            </dx-tile-view>
        </div>
    </div>
</div>

<dx-popup [showCloseButton]="true" [width]="800" [height]="700" [showTitle]="true" [title]="focusTitle"
    [dragEnabled]="false" [hideOnOutsideClick]="true" container=".dx-viewport" [(visible)]="focusImagesVisible">

    <div *dxTemplate="let data of 'content'">
        <dx-gallery [(selectedIndex)]="focusImageIndex" *ngIf="galleryVisible" [dataSource]="galleryData" [height]="700"
            [loop]="true" [showNavButtons]="true" [showIndicator]="true">
            <div *dxTemplate="let galleryItem of 'item'">
                <div class="gallery-focus-image-container">
                    <img class="gallery-focus-image" [src]="galleryItem.imageData | safeResourceURL" />
                </div>
            </div>
        </dx-gallery>
    </div>
</dx-popup>

<dx-popup [showCloseButton]="true" [width]="400" [height]="200" [showTitle]="true" i18n-title [(title)]="folderTitle"
    [dragEnabled]="true" [hideOnOutsideClick]="true" container=".dx-viewport" [(visible)]="popupVisible">

    <div *dxTemplate="let data of 'content'">
        <span i18n="@@folderName">Folder Name</span>
        <dx-text-box [(value)]="newFolderName"></dx-text-box>
        <div>
            <dx-button i18n-text [text]="isRename ? rename : add " (onClick)="submitFolderAction()"
                class="gt-button gt-primary gt-bottom gt-btn-right">
            </dx-button>
        </div>
    </div>
</dx-popup>

<dx-popup [(visible)]="confirmDeletePopupVisible" [width]="400" [height]="200" showTitle="true" title="Confirm Delete">
    <div>
        <p>Are you sure you want to delete <strong>{{ deleteTargetName }}</strong>?</p>
        <div style="display: flex; justify-content: space-between; margin-top: 20px;">
            <dx-button i18n-text text="Cancel" (onClick)="confirmDeletePopupVisible = false"></dx-button>
            <dx-button i18n-text text="Delete" type="danger" (onClick)="confirmDelete()"></dx-button>
        </div>
    </div>
</dx-popup>



<dx-popup [(visible)]="viewFile" [width]="500" [height]="500" [showCloseButton]="true" [dragEnabled]="true"
    [resizeEnabled]="true" [showTitle]="true" i18n-title="@@imagePreview" title="Image Preview"
    [hideOnOutsideClick]="true" container=".dx-viewport" class="image-preview-popup">

    <div class="image-container">
        <img [src]="fileSrc" class="preview-image" />
    </div>
</dx-popup>
